/**
 * ProgressBar is how far through something a reader is: the Continue card's
 * position in a chapter, and a library tile's finished chapters of a book
 * (ADR-0061). One bar, because the two say the same thing about different
 * denominators and a second style of bar would read as a different fact.
 *
 * It is always given a label saying what it measures. A bare bar on a tile has
 * nothing around it to say whether it means the book or the chapter.
 */
export default function ProgressBar({
  percent,
  label,
  className = "mt-2",
}: {
  percent: number;
  label: string;
  className?: string;
}) {
  return (
    <div
      className={`h-1 overflow-hidden rounded-full bg-ink/10 ${className}`}
      role="progressbar"
      aria-label={label}
      aria-valuenow={percent}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      {/* The ramp runs from where the bar starts, which is the right edge
          in a right-to-left interface. */}
      <div
        className="h-full rounded-full bg-linear-to-r from-sage-deep via-sage to-sky rtl:bg-linear-to-l"
        style={{ width: `${Math.max(2, percent)}%` }}
      />
    </div>
  );
}
